import React from 'react'
import { Box, Container, Flex } from 'rebass'

const Wrapper = props => (
  <Box {...props} is="header" bg="#222020" color="#ffffff">
    <Container
      {...props}
      w={1}
      is={Flex}
      alignItems="center"
      justifyContent="space-between"
      px={1}
      py={[1, 2, 3]}
    />
  </Box>
)

export default Wrapper



// WEBPACK FOOTER //
// ./src/containers/Layout/Header/Wrapper.js